// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"f89bd3f8","286":"f89bd3f8","290":"5d059ec0","305":"5d059ec0","372":"19cb5aec"}[chunkId] + ".chunk.css";
};